"use client";
import {
  Box,
  Avatar,
  Menu,
  MenuItem,
  Modal,
  Divider,
  Drawer,
} from "@mui/material";
import trialIcon from "../assets/images/Group.png";
import styles from "../../src/styles/layout/dashboard.module.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import settings from "../assets/images/Sidebar/setting.svg";
import notificationicon from "../assets/images/Sidebar/bell.svg";
import { useUser } from "../context/AuthContext";
import CloseIcon from "@mui/icons-material/Close";
import { get, put } from "../utils/api";
import mobile from "../assets/images/mobile.svg";
import email from "../assets/images/email.svg";
import FeatureLockedModal from "../Components/Common/FeatureLockedModal";

const MainDashboardLayout = ({ children, sidebar }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  function getUTCDateOnly(date) {
    return new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
    );
  }

  const apiDate = getUTCDateOnly(new Date(user?.trailEndDate));
  const todayUTC = getUTCDateOnly(new Date());

  const diffDays = (apiDate - todayUTC) / (1000 * 60 * 60 * 24);

  // Trial user check
  const isTrialUser = user?.isTrialUser;
  const trialDaysLeft = diffDays ?? "";

  const navbarData = [
    // { title: "Search", icon: SearchIcon },
    { title: "Setting", icon: settings, path: "/settings" },
    { title: "Notification", icon: notificationicon, modal: "notification" },
  ];

  const [profileModal, setProfileModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [featureLockedModal, setFeatureLockedModal] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setProfileModal(true);
  };

  const fetchNotifications = async () => {
    try {
      let res = await get("/notification/get");
      setNotificationData(res?.data?.data);
    } catch (error) {
      console.log("first", error);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);

  const clearNotification = async (id) => {
    try {
      const payload = id === "all" ? { type: "all" } : { notificationId: id };

      const res = await put("/notification/clear", payload);

      if (res?.data?.statusCode === 1) {
        await fetchNotifications();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    const isoString = user?.loginTime;
    if (isoString) {
      const dateObj = new Date(isoString);
      setDate(dateObj.toLocaleDateString());
      setTime(
        dateObj.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      );
    }
  }, [user?.loginTime]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("loggedOut", "true");
    window.location.href = "/login";
  };

  const headers = {
    today: "Today",
    last_7_days: "Last 7 Days",
    previous: "Previous",
  };

  const sortedOrder = ["today", "last_7_days", "previous"];

  const sortedNotifications = sortedOrder.map((key) => {
    return (
      notificationData.find((item) => item._id === key) || {
        _id: key,
        notifications: [],
      }
    );
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box className={styles.sidebar}>{sidebar}</Box>
      <Box className={styles.main}>
        <div className={styles.navbar}>
          {/* Trial Period Indicator - Only show for trial users */}
          {isTrialUser && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "10px",

                borderRadius: "50px",
                border: "1px solid #EB7E0E",
                backgroundColor: "rgba(235, 126, 14, 0.1)",
                color: "#EB7E0E",
                fontFamily: "Inter",
                fontSize: "12px",
                fontWeight: 500,
                marginRight: "1.5rem",
                height: "36px",
                size: "12px",
              }}
            >
              <img
                src={trialIcon}
                alt="trial"
                style={{ width: "18px", height: "18px" }}
              />
              <span>Trial ends in {trialDaysLeft} days</span>
            </div>
          )}

          {navbarData.map((el, index) => (
            <img
              key={index}
              src={el.icon}
              alt={el.title}
              title={el.title}
              onClick={() => {
                if (el.title === "Setting") {
                  setFeatureLockedModal(true);
                  return;
                }
                if (el.modal) {
                  setNotificationModal(!notificationModal);
                } else if (el.path) {
                  navigate(el.path);
                }
              }}
              style={{ marginRight: "1rem", cursor: "pointer", width: "24px" }}
            />
          ))}
          <Avatar
            id="navbar_user_profile_section"
            sx={{ width: 36, height: 36, mr: 3, cursor: "pointer" }}
            onClick={handleClick}
          >
            <img
              src={
                user?.groupManager
                  ? user?.groupCompanyId?.image
                  : user?.company?.companyImage
              }
              alt="profile"
              style={{ width: "100%", height: "100%" }}
            />
          </Avatar>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </div>

        <Box className={styles.children}>{children}</Box>
      </Box>

      <Modal
        open={profileModal}
        onClose={() => setProfileModal(false)}
        // aria-labelledby="modal-title"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          marginTop: "4rem",
          marginRight: "2rem",
        }}
      >
        <Box className={styles.profileContainer}>
          <div className={styles.profileHeader}>
            <p className={styles.prfileHeading}>My Profile </p>
            <p
              className={styles.closeicon}
              onClick={() => setProfileModal(false)}
            >
              X
            </p>
          </div>

          <Divider
            sx={{
              width: "100%",
              borderColor: "rgba(0, 0, 0, 0.6)",
              borderWidth: "1px",
              marginBottom: "0.5rem",
            }}
          />

          <div className={styles.profile}>
            {/* <div className={styles.companyImage}></div> */}
            <img
              src={user?.company?.companyImage}
              alt={"company"}
              className={styles.companyImage}
            />
            <div className={styles.profileDetails}>
              <div className={styles.userNameContainer}>
                <p className={styles.userName} title={user?.name}>
                  {user?.name}{" "}
                </p>
                <div className={styles.roleContainer}>
                  {user?.companyAdmin
                    ? "Admin"
                    : user?.facilityManger
                      ? "Manager"
                      : user?.groupManager
                        ? "Group Admin"
                        : "User"}
                </div>
              </div>
              <p
                className={styles.companyName}
                title={
                  user?.groupManager ? user?.image : user?.company?.companyName
                }
              >
                {user?.groupManager ? user?.image : user?.company?.companyName}
              </p>
              <p>
                <img
                  src={mobile}
                  className={styles.profileIcon}
                  alt="contact number"
                />
                <span className={styles.details} title={user?.phone}>
                  {user?.phone}
                </span>
              </p>
              <p>
                <img src={email} className={styles.profileIcon} alt="email" />
                <span className={styles.details} title={user?.email}>
                  {user?.email}
                </span>
              </p>
            </div>
          </div>

          <Divider
            sx={{
              width: "100%",
              borderColor: "rgba(0, 0, 0, 0.6)",
              borderWidth: "1px",
              marginBottom: "0.5rem",
            }}
          />

          <p className={styles.loginText}>Last Login :</p>
          <p className={styles.loginTime}>
            {date} | {time}
          </p>

          {/* <div className={styles.profile}>
            <p>
              User : <span>{user?.name}</span>
            </p>
            <p>
              Email : <span>{user?.email}</span>
            </p>
            <p>
              Phone : <span>{user?.phone}</span>
            </p>
            <p>
              Role :{" "}
              <span>
                {user?.companyAdmin
                  ? "Company Admin"
                  : user?.facilityManger
                  ? "Facility Manager"
                  : "User"}
              </span>
            </p>
            <p>
              Company : <span>{user?.company?.companyName}</span>
            </p>
          </div> */}
        </Box>
      </Modal>

      <Drawer
        anchor="right"
        open={notificationModal}
        onClose={() => setNotificationModal(false)}
        PaperProps={{
          sx: {
            width: "35%",
            display: "flex",
            flexDirection: "row",
            background: "transparent",
            boxShadow: "none",
          },
        }}
      >
        <Box
          sx={{
            width: "10%",
            height: "8vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CloseIcon
            onClick={() => setNotificationModal(false)}
            style={{
              backgroundColor: "#fff",
              borderRadius: "50%",
              cursor: "pointer",
            }}
          />
        </Box>

        <Box className={styles.notificationContainer}>
          {/* <p className={styles.notificationHeading}>Notifications</p>
          <p onClick={() => clearNotification("all")}>Clear all</p> */}
          <Box className={styles.notificationHeader}>
            <p className={styles.notificationHeading}>Notifications</p>
            <p
              className={styles.clearAllText}
              onClick={() => clearNotification("all")}
            >
              Clear all
            </p>
          </Box>

          {sortedNotifications?.map((category) => (
            <div key={category._id}>
              <p className={styles.notiHeading}>{headers[category._id]}</p>
              {category.notifications.length > 0 ? (
                category.notifications.map((item) => (
                  <div key={item._id} style={{ marginBottom: "0.5rem" }}>
                    <div className={styles.inlineItems}>
                      <div className={styles.notiRemark}>{item.message}</div>
                      <div
                        className={styles.deleteButton}
                        onClick={() => clearNotification(item?._id)}
                      >
                        x
                      </div>
                    </div>
                    <p className={styles.notiDate}>
                      {new Date(item.createdAt).toLocaleString()}
                    </p>
                  </div>
                ))
              ) : (
                <p className={styles.notiRemark1}>No notifications</p>
              )}
            </div>
          ))}
        </Box>
      </Drawer>

      <FeatureLockedModal
        open={featureLockedModal}
        onClose={() => setFeatureLockedModal(false)}
      />
    </Box>
  );
};

export default MainDashboardLayout;
